import React from 'react'
import { useParams, useHistory } from 'react-router'
import { format } from 'date-fns'
import { If, Else, Then, Switch, Case, Default } from 'react-if'
import { Table, Button, Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { FaHourglassHalf, FaCheck, FaTimes, FaFileDownload } from "react-icons/fa"
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'

// import { useSelector } from 'react-redux';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import ErrorSwal from '../../components/SwalError'
import LeaveOfYear from '../../components/LeaveOfYear/LeaveOfYearModal'
import { FindOne, LeaveTypeAPI, downloadFilesAPI } from '../../components/functions/LeaveRequestPage';
import { RejectLeaveReqAPI, ApproveLeaveReqAPI } from '../../components/functions/ApprovePage'

const Approve = () => {

    const { id } = useParams();
    const history = useHistory();
    const MySwal = withReactContent(Swal)

    const { t } = useTranslation()
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const profileValue = JSON.parse(localStorage.getItem("profile"))

    const [error, setError] = React.useState(null)
    const [Approvals, setApprovals] = React.useState([])
    const [values, setValues] = React.useState({})

    const getData = React.useCallback(async () => {
        try {
            const result = await FindOne(id)

            const TypeList = await LeaveTypeAPI()

            const v_type = TypeList.data.leaveType.find(itme => {
                return itme.TYPECD = result.data.leave.TYPECD
            })
            // console.log(result.data.leave.leaveTypes)
            setValues({
                ...values,
                EmpNo: result.data.leave.EMP_NO,
                LeaveID: result.data.leave.LEAVE_NO,
                LeaveType: v_type.TYPENM,
                Reason: result.data.leave.REASON,
                Status: result.data.leave.STATUS,
                Amount: result.data.leave.DAYS_QTY,
                Time: result.data.leave.MIN_QTY,
                ToDate: (format(new Date(result.data.leave.BEGIN_DT), 'dd/MM/yyyy')),
                EndDate: (format(new Date(result.data.leave.END_DT), 'dd/MM/yyyy')),
                ToTime: result.data.leave.BEGIN_TIME,
                EndTime: result.data.leave.END_TIME,
                fileName: result.data.leave.PATH_FILE,
                ApproveRemark: result.data.leave.SIGN_REASON,
                ApprovalStatus: checkRenderButton(result.data.leave.leaveApproval),
                leaveTypes: result.data.leave.leaveTypes
            })
            setApprovals(result.data.leave.leaveApproval)
        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
            history.replace("/dashboard")
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, setValues, setApprovals])


    React.useEffect(() => {
        // console.log('useEffect edit page')
        getData();
    }, [getData]);

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    const handleAttachedFile = (fileName) => {

        downloadFilesAPI(fileName)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', fileName)
                document.body.appendChild(link)
                link.click()
            })
    }

    const handleChangStatus = async (reason, Lid, Status) => {
        if (Status === 'reject') {
            await RejectLeaveReqAPI(Lid, reason)
        }
        else {
            await ApproveLeaveReqAPI(Lid, reason)
        }
        history.replace('/dashboard')
    }

    const checkRenderButton = (leaveApproval) => {
        let found = leaveApproval.find(function (item) {
            return item.APP_NO === JSON.parse(localStorage.getItem("profile")).EMP_NO
        });
        if (found) {
            return found.APP_STATUS
        }
        return ''

    }
    return (
        <div className="container-md">
            <div className='mt-5' style={{ paddingLeft: "1.5rem" }}>
                <Breadcrumb listTag="div" >
                    <BreadcrumbItem >
                        <Link to="/dashboard"> 	{t("t_dashboard")} </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem
                        active
                        tag="span"
                    >
                        {values.LeaveID}
                    </BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div className="card">
                <div className="card-header">
                    <h4 className="card-title">  {t("t_leave_dtl")} </h4>
                </div>
                <div className="card-content">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className='portlet light bordered'>

                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">

                                            <label className="d-inline"> {t("t_leave_type")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "2.35rem" }}>
                                                <b >
                                                    {
                                                        values.leaveTypes ? (
                                                            <Switch>
                                                                <Case condition={currentLanguageCode === 'en'}> {values.leaveTypes.TYPENM} </Case>
                                                                <Case condition={currentLanguageCode === 'th'}> {values.leaveTypes.TYPENM2} </Case>
                                                                <Case condition={currentLanguageCode === 'jp'}> {values.leaveTypes.TYPENM3} </Case>
                                                                <Default> {values.leaveTypes.TYPENM} </Default>
                                                            </Switch>
                                                        ) : (
                                                            <></>
                                                        )

                                                    }
                                                </b>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_reason")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "4.75rem" }}>
                                                <b>
                                                    {values.Reason}
                                                </b>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_status")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "5.5rem" }}>
                                                <Switch>
                                                    <Case condition={values.Status === "-3"}>
                                                        <span className="badge bg-info" style={{ color: '#fff' }}> {t("t_st_drf")} </span>
                                                    </Case>
                                                    <Case condition={values.Status === "0"}>
                                                        <span className="badge bg-warning" style={{ color: '#fff' }}> {t("t_st_ped")} </span>
                                                    </Case>
                                                    <Case condition={values.Status === "1"}>
                                                        <span className="badge bg-success" style={{ color: '#fff' }}> {t("t_st_app")} </span>
                                                    </Case>
                                                    <Case condition={values.Status === "-1"}>
                                                        <span className="badge bg-danger" style={{ color: '#fff' }}> {t("t_st_can")} </span>
                                                    </Case>
                                                    <Case condition={values.Status === "-2"}>
                                                        <span className="badge bg-danger" style={{ color: '#fff' }}> {t("t_st_rej")} </span>
                                                    </Case>
                                                </Switch>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_leave_day")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "4rem" }}>
                                                <b>
                                                    {values.Amount} {t("t_day")}
                                                </b>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_leave_time")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "2.75rem" }}>
                                                <b> {values.Time}</b>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_date_from")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "3rem" }}>
                                                <b> {values.ToDate} {values.ToTime} </b>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_date_to")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "4.25rem" }}>
                                                <b> {values.EndDate} {values.EndTime} </b>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_att_file")} :</label>
                                            <div className="d-inline font-blue-dark" style={{ marginLeft: "5rem" }}>
                                                <If condition={values.fileName !== null && values.fileName !== ''}>
                                                    <Then>
                                                        <Button color="success" outline onClick={() => handleAttachedFile(values.fileName)}> <FaFileDownload /></Button>
                                                    </Then>
                                                    <Else>
                                                        <label class="font-blue-dark">
                                                            {t("t_no_file")}
                                                        </label>
                                                    </Else>
                                                </If>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12 col-sm-12">
                                            <label className="d-inline"> {t("t_app_rmk")} :</label>
                                            <label className="d-inline font-blue-dark" style={{ marginLeft: "5rem" }}>
                                                <b> {values.ApproveRemark}  </b>
                                            </label>
                                        </div>
                                    </div>


                                    <If condition={values.Status !== "-3" && values.Status !== "-1"}>
                                        <div className="portlet light bordered">
                                            {Approvals ? (
                                                <Table striped>
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                #
                                                            </th>
                                                            <th>
                                                                {t("t_approver")}
                                                            </th>
                                                            <th>
                                                                {t("t_status")}
                                                            </th>
                                                            <th>
                                                                {t("t_app_date")}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Approvals.length > 0 ? (
                                                            Approvals.map((approval, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <th scope="row">
                                                                            {index + 1}
                                                                        </th>
                                                                        <td>
                                                                            {approval.employees.FIRST_NM}
                                                                        </td>
                                                                        <td>
                                                                            <Switch>

                                                                                <Case condition={parseInt(approval.APP_STATUS) === 0}>
                                                                                    <span className="badge bg-info" style={{ color: '#fff' }}> <FaHourglassHalf /> </span>
                                                                                </Case>
                                                                                <Case condition={parseInt(approval.APP_STATUS) > 0}>
                                                                                    <span className="badge bg-success" style={{ color: '#fff' }}> <FaCheck /> </span>

                                                                                </Case>
                                                                                <Case condition={parseInt(approval.APP_STATUS) < 0}>
                                                                                    <span className="badge bg-warning" style={{ color: '#fff' }}> <FaTimes /> </span>
                                                                                </Case>

                                                                            </Switch>
                                                                        </td>
                                                                        <td>
                                                                            {approval.UPDTD !== null ? format(new Date(approval.UPDTD), 'dd/MM/yyyy') : ''}
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        ) :
                                                            <div className='d-flex justify-content-center'>
                                                                <p className="lead">
                                                                    {t("t_no_data")}
                                                                </p>
                                                            </div>
                                                        }
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <></>
                                            )

                                            }
                                        </div>
                                    </If>
                                    {profileValue ? (
                                        <If condition={values.Status === "0" && values.ApprovalStatus === "0"}>
                                            <Then>
                                                <div className="mt-3 d-grid gap-2 d-md-flex justify-content-md-end">
                                                    <Button className="ml-2" color="success" outline
                                                        onClick={async () => {
                                                            await MySwal.fire({
                                                                title: `${t("t_title_approve")}`,
                                                                text: `${t("t_text_approve")}`,
                                                                // icon: 'question',
                                                                input: 'textarea',
                                                                inputPlaceholder: `${t("t_holder_approve")}`,
                                                                showCancelButton: true,
                                                                confirmButtonColor: '#435ebe',
                                                                cancelButtonColor: '#dc3545',
                                                                confirmButtonText: `${t("b_approve")}`,
                                                                cancelButtonText: `${t("b_cancel")}`

                                                            }).then((result) => {
                                                                if (result.isConfirmed) {
                                                                    handleChangStatus(result.value, values.LeaveID, 'approve')
                                                                    MySwal.fire(
                                                                        `${t("t_title_approval")}`,
                                                                        `${t("t_text_approval")}`,
                                                                        'success'
                                                                    )
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <FaCheck /> {t("b_approve")}
                                                    </Button>
                                                    <Button className="ml-2" color="danger" outline
                                                        onClick={async () => {
                                                            await MySwal.fire({
                                                                title: `${t("t_title_reject")}`,
                                                                text: `${t("t_text_reject")}`,
                                                                // icon: 'question',
                                                                input: 'textarea',
                                                                inputPlaceholder: `${t("t_holder_reject")}`,
                                                                showCancelButton: true,
                                                                confirmButtonColor: '#435ebe',
                                                                cancelButtonColor: '#dc3545',
                                                                confirmButtonText: `${t("b_reject")}`,
                                                                cancelButtonText: `${t("b_cancel")}`

                                                            }).then((result) => {
                                                                if (result.value === '') {
                                                                    MySwal.fire(`${t("t_req_reason")}`)
                                                                }
                                                                else if (result.isConfirmed) {
                                                                    handleChangStatus(result.value, values.LeaveID, 'reject')
                                                                    MySwal.fire(
                                                                        `${t("t_title_rejected")}`,
                                                                        `${t("t_text_rejected")}`,
                                                                        'success'
                                                                    )
                                                                }
                                                            })
                                                        }}
                                                    >
                                                        <FaTimes /> {t("b_reject")}
                                                    </Button>
                                                </div>
                                            </Then>
                                        </If>
                                    ) : (
                                        <></>
                                    )

                                    }
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6">
                                <div className="portlet light bordered">
                                    <LeaveOfYear EmpNO={values.EmpNo} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


    )
}

export default Approve